import useRemixInfoModalStore from './store';

/**
 * Custom hook for managing the RemixInfoModal
 * Provides a clean interface for opening and closing the modal
 */
const useRemixInfoModal = () => {
  const { isOpen, openModal, closeModal, toggleModal } =
    useRemixInfoModalStore();

  return {
    // State
    isOpen,

    // Actions
    openModal,
    closeModal,
    toggleModal,

    // Convenience methods
    show: openModal,
    hide: closeModal,
  };
};

export default useRemixInfoModal;
